import cx from 'clsx';
import React from 'react';

import { ReactComponent as TableSort } from '@assets/svg/table-sort.svg';

import { initialSorting } from '@constants/tableSorting';

import type { ITableSorting } from '@model/tableSorting';

import style from './style.module.scss';

interface IProps {
  sortingKey: string;
  sorting: ITableSorting;
  setSorting?: (value: ITableSorting) => void;
  tooltipId?: string;
}

const TableSorting: React.FC<IProps> = ({ sortingKey, sorting, setSorting, tooltipId }) => {
  const { id } = sorting;

  const onChangeSorting = () => {
    if (setSorting) {
      if (!sorting.id || sorting.id !== sortingKey) {
        setSorting({ id: sortingKey, desc: false });
        return;
      }
      const { id, desc } = sorting;
      if (desc) {
        setSorting(initialSorting);
      } else {
        setSorting({ id, desc: true });
      }
    }
  };

  return (
    <TableSort
      data-tooltip-content={sortingKey}
      data-tooltip-id={tooltipId}
      className={cx(style.sortIcon, { [style.activeSort]: id === sortingKey })}
      onClick={onChangeSorting}
    />
  );
};

export default TableSorting;
